






































import Vue from 'vue'

import {
  PrintingOptionModel,
  PATTERN_VIEWS
} from '@/groupBuy/types'

export default Vue.extend({
  props: {
    pattern: {
      type: Object as () => PrintingOptionModel,
      required: true
    },
    type: {
      type: Number as () => PATTERN_VIEWS,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    PATTERN_VIEWS() {
      return PATTERN_VIEWS
    }
  }
})
